import { useQuery } from '@tanstack/react-query';

const umbracoContentType = (alias: string, takeFirst: boolean = false) => {
  const takeFirstOccurance = takeFirst ? '&take=1' : '';

  return useQuery(
    ['umbracoContentType', alias],
    () =>
      fetch(
        `/umbraco/delivery/api/v2/content?filter=contentType:${alias}${takeFirstOccurance}`
      ).then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        if (takeFirst) {
          return response.json().then((data) => data?.items?.[0]);
        }
        return response.json();
      }),
    {
      enabled: !!alias, // Only run query if the pageId is not empty
      retry: 0, // Disable retries on failure
      keepPreviousData: true, // Keep old data while fetching new data
      refetchOnWindowFocus: false, // Don't refetch on window focus
      cacheTime: 1000 * 5 * 60, // Cache the data for 5 minutes
      staleTime: 1000 * 5 * 60, // Data is considered fresh for 5 minutes
    }
  );
};

export default umbracoContentType;
